let NOME_MARCA;
let URL_API;

if (window.location.hostname === 'homologacao.nbs.app.br') {
  URL_API = 'https://homologacao.nbs.app.br:7014/portal-site-api/api';
} else if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  URL_API = `http://${window.location.hostname}:8002/portal-site-api/api`;
} else if (window.location.protocol === 'http:') {
  URL_API = `http://${window.location.hostname}:8002/portal-site-api/api`;
} else {
  URL_API = `https://${window.location.hostname}:3580/portal-site-api/api`;
}

export const environment = {
  production: true,
  URL_API,
  CHAVE_ASSINATURA: '36fd5a128f10fc514a26113f2adf83065be3d2f11dbc4d04b52ab49151bcdfac'
};

export { NOME_MARCA };